import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/usedproducts.webp';
import screenshot_target from '../../../images/letterfunnel/bertholdbakker.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Berthold Bakker"
      firstname="Berthold"
      companyname="Used Products"
      competition="CeX en Swappie"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/bertholdbakker.js